/**
 * @generated SignedSource<<86644a40a8a944d6e5ddfa7a6796ba43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivityLogsQuery$variables = {
  count?: number | null | undefined;
  id: string;
  order_by?: ReadonlyArray<string | null | undefined> | null | undefined;
  page?: number | null | undefined;
};
export type ActivityLogsQuery$data = {
  readonly activityLogs: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly causer: {
          readonly first_name: string | null | undefined;
          readonly id: string;
          readonly last_name: string | null | undefined;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly causer_id: string | null | undefined;
        readonly causer_type: string | null | undefined;
        readonly created_at: string | null | undefined;
        readonly description: string | null | undefined;
        readonly event: string | null | undefined;
        readonly id: string | null | undefined;
        readonly properties: string | null | undefined;
        readonly subject_id: string | null | undefined;
        readonly subject_type: string | null | undefined;
        readonly updated_at: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly pageInfo: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly structure: ReadonlyArray<{
      readonly display: string | null | undefined;
      readonly field: string;
      readonly nest: ReadonlyArray<{
        readonly display: string | null | undefined;
        readonly field: string;
        readonly type: string;
      } | null | undefined> | null | undefined;
      readonly type: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ActivityLogsQuery = {
  response: ActivityLogsQuery$data;
  variables: ActivityLogsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order_by"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "display",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "count"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "order_by",
        "variableName": "order_by"
      },
      {
        "kind": "Variable",
        "name": "page",
        "variableName": "page"
      }
    ],
    "concreteType": "ActivityLogConnection",
    "kind": "LinkedField",
    "name": "activityLogs",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Structure",
        "kind": "LinkedField",
        "name": "structure",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Structure",
            "kind": "LinkedField",
            "name": "nest",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ActivityLogEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ActivityLog",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "event",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subject_type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "subject_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "causer_type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "causer_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "causer",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "first_name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "last_name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "properties",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created_at",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updated_at",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActivityLogsQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActivityLogsQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "956d00ca21d6ba6f4f80f0a300d05f22",
    "id": null,
    "metadata": {},
    "name": "ActivityLogsQuery",
    "operationKind": "query",
    "text": "query ActivityLogsQuery(\n  $id: String!\n  $count: Int\n  $page: Int\n  $order_by: [String]\n) {\n  activityLogs(id: $id, page: $page, first: $count, order_by: $order_by) {\n    structure {\n      field\n      type\n      display\n      nest {\n        field\n        type\n        display\n      }\n    }\n    pageInfo {\n      count\n    }\n    edges {\n      node {\n        id\n        event\n        description\n        subject_type\n        subject_id\n        causer_type\n        causer_id\n        causer {\n          id\n          name\n          first_name\n          last_name\n        }\n        properties\n        created_at\n        updated_at\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a2dd9b02f7111c555d2d35a1cc28395";

export default node;
